import { createSlice } from "@reduxjs/toolkit"

const initialStateJuicio = {
  idJuicio: ''
}

export const datosJuicioSlice = createSlice({
  name: "datosJuicio",
  initialState: initialStateJuicio,
  reducers: {
    setIdJuicio: (state, action) => {
      state.idJuicio = action.payload
    },
    resetIdJuicio: (state) => {
      state.idJuicio = initialStateJuicio.idJuicio
    }
  }
})

export const { setIdJuicio, resetIdJuicio } = datosJuicioSlice.actions
export default datosJuicioSlice.reducer
